import React from 'react';
import CommonStore from './common.store';
import UserStore from './user.store';

const commonStore = new CommonStore();
const userStore = new UserStore();

export const CommonStoreContext = React.createContext(commonStore);

export default function initStore() {
  return {
    commonStore,
    userStore,
  };
}
